import { Component } from '@theme/component';

class PlpResultsCount extends Component {
  #updateId = 0;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('shopify:collection:update', this.#handleCollectionUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('shopify:collection:update', this.#handleCollectionUpdate);
  }

  #handleCollectionUpdate = async (event) => {
    const updateId = ++this.#updateId;

    try {
      const result = await event.promise;
      if (updateId !== this.#updateId) return;

      this.#renderCount(result.productsCount);
    } catch {
      return;
    }
  };

  #renderCount(count) {
    if (!Number.isFinite(count)) return;

    const isCutoff = count > 25000;
    const displayCount = isCutoff ? 25000 : count;
    const template = isCutoff
      ? this.dataset.countCutoff
      : count === 1
        ? this.dataset.countOne
        : this.dataset.countOther;

    if (!template) return;

    const formattedCount = new Intl.NumberFormat(document.documentElement.lang).format(displayCount);
    this.textContent = template.replace('__COUNT__', formattedCount);
  }
}

if (!customElements.get('plp-results-count')) {
  customElements.define('plp-results-count', PlpResultsCount);
}
